export default __webpack_public_path__ + "static/media/wave-footer.c0485b5f.svg";